import { FormApiConformiteHonorabilite } from 'form-api';

export const honorabiliteUrl = 'honorabilite';
export type Honorabilite = FormApiConformiteHonorabilite.Honorabilite;
